import clsx from "clsx";
import React from "react";

import { useStrings } from "../../context/ConfiguratorStringsContext.ts";

import styles from "./ComponentCard.module.css";

export interface CompactCardContentProps {
	kind: string;
	displayTitle?: string;
	imageUrl?: string;
	isEmptyProduct: boolean;
	materialNumber?: string;
	productGroupId?: string;
	onSelectClick: () => void;
	onReadMoreClick: () => void;
}

const CompactCardContent: React.FC<CompactCardContentProps> = ({
	kind,
	displayTitle,
	imageUrl,
	isEmptyProduct,
	materialNumber,
	productGroupId,
	onSelectClick,
	onReadMoreClick,
}) => {
	const strings = useStrings();
	const notSelectedText = strings.product.configBundles?.notSelected?.webText1;
	const notSelectedLabel = notSelectedText
		? `${kind} (${notSelectedText})`
		: kind;
	const testIdSubject = productGroupId
		? `group-${productGroupId}`
		: `product-${materialNumber}`;

	return (
		<>
			<div
				className={clsx(styles.imageContainer, styles.imageContainerCompact)}
			>
				{isEmptyProduct ? (
					<div
						className={clsx(styles.thumbnail, styles.emptyThumbnail)}
						aria-hidden="true"
					>
						<span className={styles.emptyIcon} aria-hidden="true">
							+
						</span>
					</div>
				) : (
					<img
						src={imageUrl}
						alt={displayTitle ?? ""}
						className={styles.thumbnail}
					/>
				)}
			</div>
			<div className={clsx(styles.content, styles.contentCompact)}>
				<div className={styles.titleSection}>
					{isEmptyProduct ? (
						<div className={styles.kind}>{notSelectedLabel}</div>
					) : (
						<>
							<div className={styles.kind}>{kind}</div>
							<h3 className={clsx(styles.title, styles.titleCompact)}>
								{displayTitle}
							</h3>
						</>
					)}
				</div>
				{isEmptyProduct ? (
					<button
						className={styles.selectButton}
						onClick={onSelectClick}
						aria-label={`${strings.product.configBundles.add}: ${notSelectedLabel}`}
						data-testid={`component-card-${testIdSubject}-edit-button`}
					>
						{strings.product.configBundles.add}
					</button>
				) : (
					<button
						className={styles.linkButton}
						onClick={onReadMoreClick}
						aria-label={`${strings.product.configBundles.readMore}: ${displayTitle}`}
						data-testid={`component-card-${testIdSubject}-read-more-button`}
					>
						{strings.product.configBundles.readMore}
					</button>
				)}
			</div>
		</>
	);
};

export default CompactCardContent;
